<div class="overlay" *ngIf="overlay">
  <div class="loading-indicator">
    <mat-spinner [diameter]="size"></mat-spinner>
  </div>
</div>
  <div class="loading-indicator " *ngIf="!overlay">
    <mat-spinner [diameter]="size"></mat-spinner>
  </div>
